import { useEffect, useContext, useState } from "react";
import UserContext from "common/Context/UserContext";
import "./App.css";
import RootRouter from "common/Navigations/RootRouter";
import "./assets/Fonts/fonts.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Loading from "common/Components/Loading";
import ErrorPage from "common/Components/ErrorPage";
import { initializeUserSessionFromMe } from "common/Auth/InitializeUserSessionFromMe";

function App({ profile, publicSignupMode = false }) {
  const [loading, setLoading] = useState(false);
  const [profileError, setProfileError] = useState(null);
  const {
    loadUserInformation,
    logout,
    setCustomersList,
    setCustomerRoleOptions,
    setCustomerRoleLabelMap,
    setActiveCustomersList,
  } = useContext(UserContext);
  useEffect(() => {
    if (publicSignupMode || !profile) {
      return;
    }

    const initializeUser = async () => {
      setLoading(true);
      setProfileError(null);
      try {
        await loadUserInformation(profile);
        const sessionError = await initializeUserSessionFromMe(profile, {
          loadUserInformation,
          setCustomersList,
          setCustomerRoleOptions,
          setCustomerRoleLabelMap,
          setActiveCustomersList,
        });
        if (sessionError) {
          setProfileError(sessionError);
          return;
        }
      } catch {
        setProfileError("Failed to load user session. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    initializeUser();
  }, [profile]);

  if (loading) {
    return <Loading loadingText="Loading User Information...." />;
  }
  if (profileError) {
    return (
      <ErrorPage
        errorValue={profileError}
        handleGoBack={() => {
          logout();
        }}
        buttonTitle="Logout"
      />
    );
  }
  return <RootRouter publicSignupMode={publicSignupMode} />;
}

export default App;
